export default class Report {

  getReportName(reportType, status, executionDate = 0) {
    let titleMapping = {
        'passed': 'Passed',
        'rerun-passed': 'Failed',
        'failed': 'Failed',
        'canceled': 'Canceled',
        'done': '',
      },
      title = `- ${titleMapping[status]}`;
    switch(reportType) {
      case 'certificate':
        title = `AFSS Certificate ${(new Date(executionDate * 1000)).getFullYear()}`;
        break;
      case 'six-months':
        title = `6-Monthly Test Report ${title}`;
        break;
      case 'annual':
        title = `Annual Test Report ${title}`;
        break;
      case 'repair':
        title = `Maintenance Test Report ${title}`;
        break;
      case 'repair-detail-csv':
        title = `Maintenance Test CSV Report ${title}`;
        break;
      case 'repair-detail':
        title = `Maintenance Detailed Report ${title}`;
        break;
      case 'record':
        title = `Maintenance Record`;
        break;
      default:
        // the title for old report in old data format
        title = `Report ${title}`;
        break;
    }
    return title;
  }

  requestRecord ({store, infoModal, embedModal}, buildingId, buildingTestId, reportTitle) {
    return this.sendRequest(
      {store, infoModal, embedModal},
      {
        method: 'POST',
        path: `api/user-buildings/${buildingId}/maintenance-records/${buildingTestId}/record`,
        path_template: `/api/user-buildings/{building_id}/maintenance-records/{maintenance_record_id}/record`,
        building_id: buildingId,
        data: {
          token: true
        }
      },
      reportTitle
    );
  }

  requestReport ({store, infoModal, embedModal}, buildingId, buildingTestId, reportType, reportTitle) {
    return this.sendRequest(
      {store, infoModal, embedModal},
      {
        method: 'POST',
        path: `api/user-buildings/${buildingId}/schedule-test/${buildingTestId}/reports/${reportType}`,
        path_template: `/api/user-buildings/{building_id}/schedule-test/{building_test_id}/reports/${reportType}`,
        building_id: buildingId,
        data: {
          token: true
        }
      },
      reportTitle
    );
  }

  sendRequest ({store, infoModal, embedModal}, request, reportTitle) {
    infoModal.showModal = false;
    embedModal.showModal = false;
    return store.dispatch('apiResult', request).then(response => {
      switch (response.status) {
        case 200:
          embedModal.mime = response.data.mime;
          embedModal.url = `${response.data.path}?token=${encodeURI(response.data.token)}`;
          embedModal.showModal = true;
          break;
        default:
          infoModal.title = 'FAILED: Request' + reportTitle;
          infoModal.msg = response.data.message;
          infoModal.success = false;
          infoModal.showModal = true;
          break;
      }
    });
  }
}